angular.module('directives.dashboard').directive('wgtInfoYesterdaySale', ['DashboardApiService',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtInfoYesterdaySale/wgtInfoYesterdaySale.tpl.html',
                link: function ($scope, $element) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.widgetData = response.data;
                                $scope.isLoaded = true;
                                $scope.hasError = false;
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };
                    $scope.loadWidget();
                }
            };
        }]
);
